import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import IntrinsicElements = jsx.JSX.IntrinsicElements;

export const getStyledComponent = (tag?: keyof IntrinsicElements) => {
  switch (tag) {
    case 'nav':
      return styled.nav;
    case 'header':
      return styled.header;
    case 'main':
      return styled.main;
    case 'section':
      return styled.section;
    case 'article':
      return styled.article;
    case 'aside':
      return styled.aside;
    case 'footer':
      return styled.footer;
    case 'p':
      return styled.p;
    case 'h1':
      return styled.h1;
    case 'h2':
      return styled.h2;
    case 'h3':
      return styled.h3;
    case 'h4':
      return styled.h4;
    case 'h5':
      return styled.h5;
    case 'h6':
      return styled.h6;
    case 'ul':
      return styled.ul;
    case 'ol':
      return styled.ol;
    case 'li':
      return styled.li;
    // Add more cases as needed
    default:
      return styled.div; // Default to 'div' if no match
  }
};
